/* eslint-disable @typescript-eslint/no-namespace */
import { breakpoints } from '../breakpoints';
import type { Utility } from '../../types/utility';

export namespace PeopleSection {
  /** PeopleSection Component Variant Keys */
  export type VariantKeys = 'default' | 'threeAcross' | 'fourAcross';

  /** PeopleSecont Component Variants */
  export type Variants = {
    [Key in VariantKeys]: Utility.CSSProperties;
  };

  /** PeopleSection Component Variant Modes */
  export type VariantModes = Utility.VariantModes<Variants>;
}

const baseVariantShared: Utility.CSSProperties = {
  marginLeft: 'auto',
  marginRight: 'auto',
};

const baseListVariantShared: Utility.CSSProperties = {
  display: 'grid',
  listStyle: 'none',
  justifyContent: 'center',
  width: '100%',
  marginLeft: 0,
  gridTemplateColumns: 'repeat(1, 1fr)',
  rowGap: 's64',
  [breakpoints.bp768.min]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: 's64',
    columnGap: '180px',
  },
};

const basePeopleSection: Utility.VariantCSSKeys<PeopleSection.VariantKeys> = {
  default: {
    '& ul': {
      ...baseListVariantShared,
    },
  },
  threeAcross: {
    ...baseVariantShared,
    maxWidth: '780px',
    [breakpoints.bp1024.min]: {
      maxWidth: 'none',
    },
    '& ul': {
      ...baseListVariantShared,
      [breakpoints.bp1024.min]: {
        gridTemplateColumns: 'repeat(3, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: '180px',
      },
    },
  },
  fourAcross: {
    ...baseVariantShared,
    maxWidth: '380px',
    [breakpoints.bp1024.min]: {
      maxWidth: 'none',
    },
    '& ul': {
      ...baseListVariantShared,
      margin: '0 auto',
      maxWidth: '260px',
      [breakpoints.bp768.min]: {
        gridTemplateColumns: 'repeat(1, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: '180px',
      },
      [breakpoints.bp1024.min]: {
        maxWidth: 'none',
        gridTemplateColumns: 'repeat(4, minmax(150px, 1fr))',
        rowGap: 's64',
        columnGap: 's64',
      },
    },
  },
};

const peopleSection: Utility.VariantKeyModes<PeopleSection.VariantKeys> = {
  products: {
    chart: basePeopleSection,
    chartblog: basePeopleSection,
    co: basePeopleSection,
    edu: basePeopleSection,
    scale: basePeopleSection,
    spark: basePeopleSection,
  },
};

export const peopleSectionVariants = Object.keys(basePeopleSection) as PeopleSection.VariantKeys[];

export default peopleSection;
